import { log } from 'utils/logger'

export default function addPolyfills() {
  return Promise.all([importSmoothScroll(), importResizeObserver(), importIntersectionObserver(), importIntl()])
}

async function importSmoothScroll() {
  if (!('scrollBehavior' in document.documentElement.style && window.__forceSmoothScrollPolyfill__ !== true)) {
    const smoothscroll = await import('smoothscroll-polyfill')
    smoothscroll.polyfill()
  }
}

async function importResizeObserver() {
  if (!('ResizeObserver' in window)) {
    const ResizeObserver = await import('resize-observer-polyfill/')
    window.ResizeObserver = ResizeObserver.default
  }
}

async function importIntersectionObserver() {
  if (
    !(
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    )
  ) {
    await import('intersection-observer')
  }
}

async function importIntl() {
  try {
    const polyfillPromises = []

    // Check if Intl is available
    if (!('Intl' in window)) {
      // Load the core Intl polyfill and locale data in parallel
      polyfillPromises.push(
        Promise.all([import('intl'), import('intl/locale-data/jsonp/en.js'), import('intl/locale-data/jsonp/fr.js')]),
      )
    }

    // Check and polyfill PluralRules if needed
    if ('Intl' in window && !Intl.PluralRules) {
      polyfillPromises.push(import('@formatjs/intl-pluralrules/polyfill'))
    }

    // Check and polyfill RelativeTimeFormat if needed
    if ('Intl' in window && !Intl.RelativeTimeFormat) {
      // Load polyfill first, then locale data
      polyfillPromises.push(
        import('@formatjs/intl-relativetimeformat/polyfill').then(() =>
          Promise.all([
            import('@formatjs/intl-relativetimeformat/locale-data/en'),
            import('@formatjs/intl-relativetimeformat/locale-data/fr'),
          ]),
        ),
      )
    }

    // Wait for all polyfills to load
    await Promise.all(polyfillPromises)
  } catch (error) {
    log.warning('Failed to load Intl polyfills:', error)
    // Don't throw - let the app continue without polyfills
  }
}
